/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
  production: false,
  firebase: {
    apiKey: "AIzaSyBLLLzZPy8XAtI70LF4s8La8y99Qjgf8Vk",
    authDomain: "myndlist-d22d9.firebaseapp.com",
    databaseURL: "https://myndlist-d22d9.firebaseio.com",
    projectId: "myndlist-d22d9",
    storageBucket: "myndlist-d22d9.appspot.com",
    messagingSenderId: "841082219351",
    appId: "1:841082219351:web:94a87437a6c19d2c"
  },
  graphql: {
    uri: "https://myndlist.herokuapp.com/v1/graphql",
    secret: "1L%Ff$Pv@&A8"
  }
};
